import { CONFIRMATION_TYPE, type FormConfirmation } from '../types/forms';
import { getStoredConfirmationType } from './confirmationFields';

type ConfirmationLike = Partial<FormConfirmation> & {
  confirmationType?: CONFIRMATION_TYPE;
  type?: CONFIRMATION_TYPE;
  contentRedirectUrl?: string | null;
  contentBlocks?: unknown[] | null;
};

export function resolveConfirmationType(
  confirmation?: ConfirmationLike | null,
): CONFIRMATION_TYPE {
  if (!confirmation) {
    return CONFIRMATION_TYPE.MESSAGE;
  }

  const type = getStoredConfirmationType(confirmation) as CONFIRMATION_TYPE | undefined;
  if (
    type === CONFIRMATION_TYPE.MESSAGE
    || type === CONFIRMATION_TYPE.BLOCKS
    || type === CONFIRMATION_TYPE.REDIRECT
    || type === CONFIRMATION_TYPE.AUTOMATED_REDIRECT
    || type === CONFIRMATION_TYPE.PAGE
  ) {
    return type;
  }

  if (confirmation.contentRedirectUrl) {
    return CONFIRMATION_TYPE.REDIRECT;
  }

  if (confirmation.contentBlocks?.length) {
    return CONFIRMATION_TYPE.BLOCKS;
  }

  return CONFIRMATION_TYPE.MESSAGE;
}
